import httpApi from '@vue3/utils/http-api'
import { api } from '@vue3/configs'

export default {
  getCreditNoteCount: (params) => {
    return httpApi.getDataViaApi({
      url: api.creditNote.getCreditNoteCount,
      queryParams: params
    })
  },
  getAvailableCreditNote: (params) => {
    return httpApi.getDataViaApi({
      url: api.creditNote.getAvailableCreditNote,
      queryParams: params
    })
  },
  downloadCreditNotePdf: (params) => {
    return httpApi.fileDownloadViaApi({
      url: api.creditNote.downloadCreditNotePdf,
      queryParams: params
    })
  },
  getAvailableQuotation: (params) => {
    return httpApi.getDataViaApi({
      url: api.creditNote.getAvailableQuotation,
      queryParams: params
    })
  },
  createClaimRequest: (params, body) => {
    return httpApi.postDataViaApi({
      url: api.creditNote.createClaimRequest,
      queryParams: params,
      body
    })
  },
  requestActivation: (params, body) => {
    return httpApi.postDataViaApi({
      url: api.creditNote.requestActivation,
      queryParams: params,
      body
    })
  },
  uploadCreditNoteFile: (body) => {
    return httpApi.uploadFileViaApi({
      url: api.creditNote.uploadFile,
      body
    })
  }
}
